import React, { useState, useEffect, useMemo } from "react";
import { MdMoreHoriz } from "react-icons/md";
import { Link } from "react-router-dom";
import { getCoins } from "../services/api";
import coinbg from "../images/coinbg.png";
import SearchBar from "./SearchBar";

const getStatusBadge = (isActive) => (
  <span
    className={`px-2 py-1 uppercase font-semibold border-2 rounded-full ${
      isActive
        ? "border-blue-500 text-blue-500 "
        : "border-red-500 text-red-500"
    }`}
  >
    {isActive ? "active" : "inactive"}
  </span>
);

const CoinTable = () => {
  const [query, setQuery] = useState("");
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Memoize the fetchCoins function
  const fetchCoins = useMemo(
    () => async () => {
      try {
        setLoading(true);
        const response = await getCoins();
        console.log("getCoins Response:", response.data);
        const filteredResult = response.data.filter(
          (currency) =>
            currency.name.toLowerCase().includes(query.toLowerCase()) ||
            currency.symbol.toLowerCase().includes(query.toLowerCase())
        );
        setResult(filteredResult.slice(0, 10));
        setLoading(false);
      } catch (error) {
        setError("Ops...looks like we are having problems, please refresh.");
      }
    },
    [query]
  );

  // Fetch top coins when the component mounts
  useEffect(() => {
    fetchCoins();
  }, [fetchCoins]);

  return (
    <div className="relative z-10 py-14">
      <div>
        <img
          src={coinbg}
          className="z-0 w-full h-full absoulute"
          alt="Herobg"
        />
      </div>
      <div className="container relative z-10 px-4 mt-12">
        <p className="font-bold text-5xl text-center text-slate-800 mb-12">
          Take a look at the top
          <span className="italic font-medium px-3"> Crypto's</span>
          of today!
        </p>

        <SearchBar query={query} setQuery={setQuery} />
        {loading && !!error && (
          <p className="my-4 font-bold text-center text-blue-500">Loading...</p>
        )}
        {error && (
          <div className="text-center text-red-500 font-bold mt-32">
            {error}
          </div>
        )}
        {/* Table design */}
        <div className="h-full mt-8 space-x-32 overflow-auto">
          <table className="w-full overflow-scroll text-sm font-light text-left">
            <thead className="font-medium border-b dark:border-neutral-500">
              <tr>
                {["Rank", "Name", "Symbol", "Type", "Status"].map(
                  (columnName, index) => (
                    <th key={index} scope="col" className="px-6 py-4">
                      {columnName}
                    </th>
                  )
                )}
              </tr>
            </thead>

            <tbody className="">
              {query.trim() === ""
                ? result.map((currency) => (
                    <tr
                      className="transition duration-300 ease-in-out border-b hover:bg-blue-600 hover:bg-opacity-5"
                      key={currency.id}
                    >
                      {[
                        { link: true, text: currency.rank },
                        { link: true, text: currency.name },
                        { link: true, text: currency.symbol },
                        { link: true, text: currency.type },
                        {
                          link: true,
                          text: getStatusBadge(currency.is_active),
                        },
                        {
                          link: true,
                          text: <MdMoreHoriz />,
                        },
                      ].map((column, index) => (
                        <td
                          key={index}
                          className={`px-6 py-4 whitespace-nowrap ${
                            column.link ? "font-medium" : ""
                          }`}
                        >
                          {column.link ? (
                            <Link to={`/CryptocurrenciesDetail/${currency.id}`}>
                              {column.text}
                            </Link>
                          ) : (
                            column.text
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                : result.map((currency) => (
                    <tr
                      className="transition duration-300 ease-in-out border-b hover:bg-blue-600 hover:bg-opacity-5"
                      key={currency.id}
                    >
                      {[
                        { link: true, text: currency.rank },
                        { link: true, text: currency.name },
                        { link: true, text: currency.symbol },
                        { link: true, text: currency.type },
                        {
                          link: true,
                          text: getStatusBadge(currency.is_active),
                        },
                        {
                          link: true,
                          text: <MdMoreHoriz />,
                        },
                      ].map((column, index) => (
                        <td
                          key={index}
                          className={`px-6 py-4 whitespace-nowrap ${
                            column.link ? "font-medium" : ""
                          }`}
                        >
                          {column.link ? (
                            <Link to={`/CryptocurrenciesDetail/${currency.id}`}>
                              {column.text}
                            </Link>
                          ) : (
                            column.text
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CoinTable;
